// src/components/common/SEO.jsx
// Lightweight per-page SEO — updates document.title + meta tags via DOM
// Works with Google (JS-rendered) and pre-render tools.
import { useEffect } from "react";

const SITE_NAME = "Ravi TestPapers";
const SITE_URL  = "https://ravitestpapers.com";
const DEFAULT_IMG = "https://ravitestpapers.com/logo-black.png";

const DEFAULT_TITLE = "Ravi TestPapers | Free Tamil Nadu Question Papers — State Board, CBSE & Competitive";
const DEFAULT_DESC  = "Free question papers for Tamil Nadu State Board, CBSE, JEE, NEET & TNPSC — Classes 1 to 12, all subjects, view online. Updated every term. Expert maths home tuition & tuition centre in Chennai.";

// Updates a <meta> tag, creating it if index.html doesn't have one.
// selector is always of the form meta[name="x"] or meta[property="x"].
function setMeta(selector, attr, value) {
  let el = document.querySelector(selector);
  if (!el) {
    const [, keyAttr, keyValue] = selector.match(/\[(\w+)="([^"]+)"\]/);
    el = document.createElement("meta");
    el.setAttribute(keyAttr, keyValue);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function SEO({
  title,
  description,
  canonical,
  image,
  type = "website",
  noIndex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const fullDesc  = description || DEFAULT_DESC;
  const fullUrl   = canonical ? `${SITE_URL}${canonical}` : window.location.href;
  const fullImg   = image || DEFAULT_IMG;

  useEffect(() => {
    // Title
    document.title = fullTitle;

    // Basic meta
    setMeta('meta[name="description"]',   "content", fullDesc);
    setMeta('meta[name="robots"]',        "content", noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");

    // Canonical
    let canonTag = document.querySelector('link[rel="canonical"]');
    if (!canonTag) {
      canonTag = document.createElement("link");
      canonTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonTag);
    }
    canonTag.setAttribute("href", fullUrl);

    // Open Graph
    setMeta('meta[property="og:title"]',       "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", fullDesc);
    setMeta('meta[property="og:url"]',         "content", fullUrl);
    setMeta('meta[property="og:image"]',       "content", fullImg);
    setMeta('meta[property="og:type"]',        "content", type);

    // Twitter
    setMeta('meta[name="twitter:title"]',       "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", fullDesc);
    setMeta('meta[name="twitter:image"]',       "content", fullImg);
  }, [fullTitle, fullDesc, fullUrl, fullImg, type, noIndex]);

  return null;
}
